export const left_title = "1. Version";
export const right_title = "2. User Information";
export const link = "Submit Remote Modeling";

export const content_title_2 = "Submit a New Job";
export const content_3 =
  "By using the BREEZE Remote Modeling System you are agreeing to the terms of the Remote Modeling License Agreement.";
export const uploadTitle =
  "To begin, click CHOOSE FILE to start uploading files from your computer:";
export const uploadLink = "Choose File";

export const versionData = [
  {
    number: "19191 64-bit",
  },
  {
    number: "19191 32-bit",
  },
  {
    number: "18081 64-bit",
  },
  {
    number: "18081 32-bit",
  },
  {
    number: "16216r",
  },
  {
    number: "15181",
  },
  {
    number: "14134",
  },
  {
    number: "13350",
  },
  {
    number: "12345",
  },
  {
    number: "12060",
  },
  {
    number: "09292",
  },
  {
    number: "07026",
  },
];
